import { solidstate } from ":setup/qstate";
import { createEffect, Show } from "solid-js";
import { URLViewer, type Props as URLViewerProps } from "./url-viewer";
import type { TeamData } from "../../_model";

export type Props = { entity: TeamData; onUrl?: (show: boolean) => void };
export function Information(props: Props) {
  const $url = solidstate.create(undefined as URLViewerProps["url"]);
  const team_info_keys: (keyof TeamData)[] = [
    "problem_statement",
    "applicable_solution",
    "impact",
    "business_model",
    "feasibility",
    "ideation",
    "research_process",
  ];
  type URLTypes = typeof $url.value.type;

  createEffect(() => {
    const url = $url.value;
    const show = url == undefined ? false : true;
    props.onUrl?.(show);
  });
  // console.log("project image :: ", props);
  function showURL(e: Event, _url: typeof $url.value) {
    e.preventDefault();
    if (_url.type === "link") {
      let link = _url.url; //"https://www.youtube.com/watch?v=yvNFZhEruUg";
      if (link.includes("youtube")) {
        if (link.includes("/shorts")) {
          window.open(link, "_newtab");
          return;
        } else if (!link.includes("embed")) {
          link = link.replace("watch?v=", "embed/");
          const idx = link.indexOf("&");
          if (idx >= 0) {
            link = link.slice(0, idx);
          }
        }
      }
      // console.log("url link :: ", link);
      _url.url = link;
    }
    $url.set(_url);
    // form_transit.set(false);
  }

  function Info(props: { title: string; value: string }) {
    return (
      <p class="grid grid-cols-[35%_1fr] w-full h-full items-center justify-center text-center gap-1 <sm:(grid-cols-1 !grid-rows-[35px_50px] !items-start)">
        <span class="h-fit text-text-alt font-bold truncate text-1.2em sm:text-start">{props.title}</span>
        <span class="w-full h-fit capitalize line-clamp-2 sm:(text-start)">{props.value}</span>
      </p>
    );
  }

  function InfoURL(props: { title: string; value: string; type: URLTypes }) {
    return (
      <p class="grid grid-cols-[35%_1fr] w-full h-full items-center justify-center text-center content-start gap-1 <sm:(!grid-cols-1 !grid-rows-[35px_40px] !items-start)">
        <span class="h-fit text-text-alt font-bold truncate text-1.2em sm:text-start">{props.title}</span>
        <span class="flex w-full h-full">
          <button
            class="form-btn  !w-fit !h-35px !text-0.9em !whitespace-nowrap !font-bold <sm:(!h-40px !items-center !justify-center !self-center !w-full)"
            disabled={props.value == undefined}
            onClick={(e) => {
              showURL(e, {
                url: props.value,
                type: props.type,
              });
            }}
          >
            {props.value == undefined ? "Not Provided" : "View"}
          </button>
        </span>
      </p>
    );
  }

  function QAndA(props: { question: string; answer: string }) {
    return (
      <p class="flex flex-col !w-full bg-bg-alt items-start px3 pt2 pb4 mt2 h-fit gap-y-2 text-0.65rem rounded-xl">
        <span class="text-brand capitalize">{props.question}</span>
        <span class={"" + " " + (props.answer == undefined ? "opacity-50" : "")}>
          {String(props.answer ?? "unanswered")}
        </span>
      </p>
    );
  }
  return (
    <Show when={$url.value == undefined} fallback={<URLViewer url={$url.value} onExit={() => $url.set(undefined)} />}>
      <section
        class={`flex flex-col w-full h-full text-0.6em px-1 overflow-y-auto overflow-x-hidden scrollbar transition-all duration-300 ease-in-out`}
      >
        <div class="grid grid-cols-3 w-full h-fit gap-2 <sm:(!grid-cols-2 gap-1)">
          <Info title={`Team ${props.entity.id}`} value={props.entity?.team_name ?? "not specified"} />
          <Info title={`Project`} value={props.entity?.project_name ?? "not specified"} />
          <Info title={`Track`} value={props.entity?.track ?? "not specified"} />
          <InfoURL title="Presentation" value={props.entity?.presentation} type="pdf" />
          <InfoURL title="File" value={props.entity?.project_images} type="pdf" />
          <InfoURL title="Video" value={props.entity?.project_video} type="link" />
        </div>
        <div class="flex flex-col w-full h-full">
          {team_info_keys.map((ti, i) => {
            const title = String(!ti ? "Untitled Question" : ti.replaceAll("_", " "));
            const value = props.entity?.[ti] as any;
            return <QAndA question={title} answer={value} />;
          })}
        </div>
      </section>
    </Show>
  );
}
